export const enum LeadsStatusType {
    NO_ANSWER = 1,
    NOT_AVAILABLE = 2,
    NOT_INTERESTED = 3,
    NOT_NOW_IN_THE_FUTURE = 4,
    WRONG_NUMBER = 5,
    NOT_IN_SERVICE = 6,
    OUT_OF_BUSINESS = 7,
    SELLING_BUSINESS = 8,
    SCHEDULED_CALL_BACK = 9,
    GENERATE_LEAD = 10,
    NON_QUALIFIED = 11,
    EXISTING_MERCHANT = 12,
    TRASH = 13
}

export const enum LeadsReasonType {
    TOO_EXPENSIVE = 1,
    DOESNT_NEED_MONEY = 2,
    SELLING_BUSINESS_REASON = 3,
    RETIRING = 4,
    RECEIVED_MONEY_ELSEWHERE = 5,
    NOT_ENOUGHT_MONEY = 6,
    WITHHOLDING = 7,
    NO_PURPOSE = 8,
    CLOTHING_BUSINESS = 9,
    OTHER_REASON = 10
}



// WEBPACK FOOTER //
// ./src/app/models/leads/leads.type.ts